export default "__VITE_ASSET__Uav_eVnz__"